import React from "react";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function StagesAutoComplete({ params, disabled, options, label, width, sx }) {
  // Destructure to prevent custom props from being passed to DOM
  const { value, onChange, error, errorLabel, isFieldValid, onCustomChange, ...autocompleteProps } = params;

  return (
    <Autocomplete
      disableClearable
      disabled={disabled}
      options={options}
      value={value}
      onChange={onChange}
      {...autocompleteProps}
      isOptionEqualToValue={(option, value) => {
        if (!value || value === "" || value.stageName === "") {
          return true;
        }
        return option.stageName === value.stageName;
      }}
      getOptionLabel={(option) => {
        if (option === "") {
          return "";
        }
        return option.stageName;
      }}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        return (
          <li key={option._id || option.id || option.stageName} {...otherProps}>
            {option.stageName}
          </li>
        );
      }}
      sx={{ ...sx, width: width }}
      renderInput={(inputParams) => (
        <TextField 
          {...inputParams} 
          label={label} 
          required 
          error={error || undefined}
          helperText={error ? errorLabel : ""}
        />
      )}
    />
  );
}
